document.addEventListener('DOMContentLoaded', function () {
    const headerIco = document.getElementById('mobile-ico');
    const mobileMenu = document.getElementById('mobile-menu');
    const icoMob = document.getElementById('ico-mob');
    const icoMobClose = document.getElementById('ico-mob__close');
    const body = document.body;

    headerIco.addEventListener('click', function () {
        if (mobileMenu.style.right !== '0px') {
            mobileMenu.style.right = '0px';
            body.style.overflowY = 'hidden';
            icoMob.style.width = '0';
            icoMobClose.style.width = '24px';
        } else {
            mobileMenu.style.right = '-100vw';
            body.style.overflowY = 'auto';
            icoMob.style.width = '24px';
            icoMobClose.style.width = '0';
        }
    });
});
